<advanced-filter [showOnlyState]="true" (onSubmit)="applyFilter()"></advanced-filter>

<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>

<wl-card heading="Inactive / Stale Users Report" *ngIf="submitted">

  <div class="text-right p-custom-4px">
    <button mat-raised-button color="primary"
      class="export-excel-btn"
      [ngClass]="{'export-excel-btn-disabled': !reportData.length}"
      (click)="exportExcel()"
      [disabled]="!reportData.length">
      📥 Export Excel
    </button>
  </div>

  <div *ngIf="errorMsg && !loading"
    class="bg-f8d7da border-f5c6cb border-radius-4 p-12px-16px text-721c24 font-size-13px m-0-4px">
    {{ errorMsg }}
  </div>

  <div *ngIf="!errorMsg">

    <div *ngIf="!submitted" class="text-center p-40px text-888">
      Please select State, Zone, Region and click Submit to view the report.
    </div>

    <div *ngIf="submitted && !reportData.length && !loading" class="text-center p-40px text-888">
      No stale accounts found.
    </div>

    <div *ngIf="reportData.length " child-container class="overflow-x-auto">
      <table class="table table-hover w-full min-w-900px border-collapse">
        <thead>
          <tr>
            <th class="white-space-nowrap p-8px-10px">#</th>
            <th class="white-space-nowrap p-8px-10px">Staff ID</th>
            <th class="white-space-nowrap p-8px-10px">Full Name</th>
            <th class="white-space-nowrap p-8px-10px">Branch</th>
            <th class="white-space-nowrap p-8px-10px">Zone</th>
            <th class="white-space-nowrap p-8px-10px">Last Login Date</th>
            <th class="white-space-nowrap p-8px-10px">Account Status</th>
            <th class="white-space-nowrap p-8px-10px">Days Since Last Login</th>
            <th class="white-space-nowrap p-8px-10px">Disabled Date</th>
            <th class="white-space-nowrap p-8px-10px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of reportData; let i = index">
            <td class="vertical-align-middle p-8px">{{ i + 1 }}</td>
            <td class="vertical-align-middle p-8px">{{ row.staffId || '—' }}</td>
            <td class="vertical-align-middle p-8px white-space-nowrap">{{ row.staffName || '—' }}</td>
            <td class="vertical-align-middle p-8px">{{ row.branch_name || '—' }}</td>
            <td class="vertical-align-middle p-8px">{{ row.zone_name || '—' }}</td>
            <td class="vertical-align-middle p-8px white-space-nowrap">{{ row.last_login_timestamp ? (row.last_login_timestamp | date:'dd-MM-yyyy hh:mm a') : '—' }}</td>
            <td class="vertical-align-middle p-8px">{{ row.login_status || '—' }}</td>
            <td class="cell-custom">{{ row.daysSinceLastLogin !== '—' ? (row.daysSinceLastLogin + ' days') : '—' }}</td>
            <td class="vertical-align-middle p-8px white-space-nowrap">{{ row.disabled_date ? (row.disabled_date | date:'dd-MM-yyyy hh:mm a') : '—' }}</td>
            <td class="vertical-align-middle p-8px">
              <button mat-raised-button class="button" (click)="unlockStaleUsers(row.id)" [disabled]="!row.staffId">Unlock</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</wl-card>

